export const REDUCER_NAME = 'email'



// WEBPACK FOOTER //
// ./src/modules/email/state/const.js